
import { useState } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";

const COUNTRIES = [
  // Top commonly used countries first
  "United Kingdom",
  "United States",
  "Canada",
  "Australia",
  "Germany",
  "France",
  "Italy",
  "Spain",
  "Netherlands",
  "Belgium",
  "Sweden",
  "Norway",
  "Denmark",
  "Ireland",
  "Switzerland",
  "Austria",
  "Poland",
  "Japan",
  "South Korea",
  "Singapore",
  // Rest of the world in alphabetical order
  "Afghanistan",
  "Albania",
  "Algeria",
  "Argentina",
  "Armenia",
  "Bangladesh",
  "Belarus",
  "Bolivia",
  "Bosnia and Herzegovina",
  "Brazil",
  "Bulgaria",
  "Chile",
  "China",
  "Colombia",
  "Costa Rica",
  "Croatia",
  "Czech Republic",
  "Ecuador",
  "Egypt",
  "Estonia",
  "Finland",
  "Georgia",
  "Ghana",
  "Greece",
  "Guatemala",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran",
  "Iraq",
  "Israel",
  "Jamaica",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kuwait",
  "Latvia",
  "Lebanon",
  "Lithuania",
  "Luxembourg",
  "Malaysia",
  "Malta",
  "Mexico",
  "Morocco",
  "Nepal",
  "New Zealand",
  "Nigeria",
  "North Korea",
  "Pakistan",
  "Peru",
  "Philippines",
  "Portugal",
  "Romania",
  "Russia",
  "Saudi Arabia",
  "Serbia",
  "Slovakia",
  "Slovenia",
  "South Africa",
  "Sri Lanka",
  "Thailand",
  "Turkey",
  "Ukraine",
  "United Arab Emirates",
  "Uruguay",
  "Venezuela",
  "Vietnam",
  "Zimbabwe"
];

interface CountrySelectProps {
  value?: string;
  onValueChange?: (value: string) => void;
  placeholder?: string;
  className?: string;
}

export const CountrySelect = ({ value, onValueChange, placeholder = "Select country", className }: CountrySelectProps) => {
  const [open, setOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const filteredCountries = COUNTRIES.filter(country =>
    country.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSelect = (selectedValue: string) => {
    console.log("🔍 CountrySelect handleSelect called with:", selectedValue);
    console.log("🔍 Selected value type:", typeof selectedValue);
    
    onValueChange?.(selectedValue);
    setOpen(false);
    setSearchTerm("");
  };

  console.log("🔍 CountrySelect render - current value:", value);
  console.log("🔍 CountrySelect render - value type:", typeof value);

  return (
    <Select value={value} onValueChange={handleSelect} open={open} onOpenChange={setOpen}>
      <SelectTrigger className={className}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent className="max-h-[300px]">
        <div className="sticky top-0 z-10 bg-background border-b p-2">
          <div className="relative">
            <Search className="absolute left-2 top-1/2 transform -translate-y-1/2 text-muted-foreground h-4 w-4" />
            <Input
              placeholder="Search countries..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="pl-8 h-8"
            />
          </div>
        </div>
        <div className="max-h-[200px] overflow-y-auto">
          {filteredCountries.length > 0 ? (
            filteredCountries.map((country) => (
              <SelectItem key={country} value={country}>
                {country}
              </SelectItem>
            ))
          ) : (
            <div className="p-2 text-center text-muted-foreground text-sm">
              No countries found
            </div>
          )}
        </div>
      </SelectContent>
    </Select>
  );
};
